import { useEffect, useState } from 'react';
import { X, Loader2, Download } from 'lucide-react';
import { contractService } from '../_shared/api';
import { useModalKeys } from '../../../hooks/useModalKeys';

/**
 * ImageViewer — visualizador fullscreen pra documentos dos contratos.
 * Porte direto do apps/prospect-web.
 */
interface Props {
  contractId: string;
  docId: string | null;
  onClose: () => void;
}

export default function ImageViewer({ contractId, docId, onClose }: Props) {
  const [data, setData] = useState<{ full: string; fileName: string; descricao: string } | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!docId) {
      setData(null);
      return;
    }
    setLoading(true);
    contractService
      .getDocumentFull(contractId, docId)
      .then(setData)
      .catch(() => alert('Não foi possível carregar a imagem.'))
      .finally(() => setLoading(false));
  }, [contractId, docId]);

  // Esc fecha SÓ o viewer (topo da pilha — o modal de detalhes fica aberto)
  useModalKeys(onClose, undefined, !!docId);

  if (!docId) return null;

  function handleDownload(): void {
    if (!data) return;
    const a = document.createElement('a');
    a.href = data.full;
    a.download = data.fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  return (
    <div className="fixed inset-0 z-[80] bg-black flex flex-col">
      <header className="flex items-center gap-3 px-4 py-3 text-fg">
        <button
          onClick={onClose}
          className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"
        >
          <X size={20} />
        </button>
        <div className="flex-1 min-w-0">
          {data && (
            <>
              <p className="font-medium truncate">{data.descricao || data.fileName}</p>
              {data.descricao && (
                <p className="text-xs text-fg-2 truncate">{data.fileName}</p>
              )}
            </>
          )}
        </div>
        {data && (
          <button
            onClick={handleDownload}
            className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"
            title="Baixar"
          >
            <Download size={18} />
          </button>
        )}
      </header>

      <div className="flex-1 flex items-center justify-center p-4 overflow-hidden">
        {loading ? (
          <Loader2 size={36} className="animate-spin text-primary" />
        ) : data ? (
          <img
            src={data.full}
            alt={data.descricao}
            className="max-w-full max-h-full object-contain"
          />
        ) : (
          <p className="text-muted">Não foi possível carregar a imagem.</p>
        )}
      </div>
    </div>
  );
}
